module.exports = __webpack_public_path__ + "img/upcoming-auction-1.960a3100.png";